import React from 'react';
import MarketServiceGenericService from "./MarketServiceGenericService";

function ReleasabilityService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/releasability/`;
    return (<MarketServiceGenericService
        endpointUrl={endpointUrl}
        pageName={"Releasability Service"}
    />);
}

export default ReleasabilityService;